<app-back-button></app-back-button>
<div class="loading-container" [nbSpinner]="loading">
    <article class="attached-card attached-card-full" *ngIf="attachment">
        <h3 class="attached-card-title">{{ attachment.description }}</h3>
        <div class="attached-card-content" [innerHTML]="attachment.text_full"></div>
        <div class="attached-card-footer">
            <!-- prettier-ignore -->
            <span class="attached-card-date">{{ attachment.dt_document }}</span>
        </div>
    </article>
</div>
